import { ProductInventoryType } from '../../types/inventory/ProductInventoryType';
import { request } from '../../utils/request';

type ResType = {
  data: Array<ProductInventoryType>;
  pagination: {
    page: number;
    limit: number;
    total_count: number;
    total_pages: number;
  };
};

export const getProductsInventory = (
  store_id: number,
  authToken: string,
  filters?: Record<string, string>
): Promise<ResType> => {
  const filter = new URLSearchParams(filters).toString();

  return request({
    method: 'GET',
    url: `/products/inventory?store_id=${store_id}${filter ? `&${filter}` : ''}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
